import * as lexModalActionType from '../actionsType/lexModal.actionType';

export const initialState = {
    modal: false
};

export function lexModalReducer(state = initialState, action) {
    switch (action.type) {
        case lexModalActionType.SET_LEX_MODAL:
            return {...state, modal: action.payload};
        default:
            return state;
    }
}
